import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import FormsAPI from '../../api/forms';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getForms(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getFormById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getForms({ commit }) {
    commit(types.SET_FORM_UI_FLAG, { isFetching: true });
    try {
      const response = await FormsAPI.get();
      commit(types.SET_FORMS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_FORM_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createForm({ commit }, formData) {
    commit(types.SET_FORM_UI_FLAG, { isCreating: true });
    try {
      const response = await FormsAPI.create(formData);
      commit(types.ADD_FORM, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_FORM_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateForm({ commit }, { id, ...updateObj }) {
    commit(types.SET_FORM_UI_FLAG, { isUpdating: true });
    try {
      const response = await FormsAPI.update(id, updateObj);
      commit(types.EDIT_FORM, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_FORM_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteForm({ commit }, id) {
    commit(types.SET_FORM_UI_FLAG, { isDeleting: true });
    try {
      await FormsAPI.delete(id);
      commit(types.DELETE_FORM, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_FORM_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_FORM_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_FORMS]: MutationHelpers.set,
  [types.ADD_FORM]: MutationHelpers.create,
  [types.EDIT_FORM]: MutationHelpers.update,
  [types.DELETE_FORM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
